@if (!router.url.includes('login')) {
  <app-header (menuToggled)="isMenuOpen = !isMenuOpen"></app-header>
}
@if (!router.url.includes('nueva-operacion')) {
  <app-sidebar [isMenuOpen]="isMenuOpen"></app-sidebar>
}

<div class="content" [class.menu-open]="isMenuOpen && !router.url.includes('nueva-operacion')">
  <router-outlet />
</div>